<template>

  <div>
    <el-dialog
      width="1000px"
      v-loading="loadingData"
      :visible="historyModalVisible"
      :before-close="handleCloseModal"
      :close-on-click-modal="false"
      @opened="buildFlowChart"
    >

      <div class="call-flow-info mb-10" v-if="currentCall">
        <h2 class="form-section-header">
          Call Flow View
        </h2>
        <div class="flex-three">
          <div class="call-flow-info-item flex">
            <h4 class="black-text mt-0 mb-0">Unique Id: </h4>
            <span class="ml-10 black-text">{{currentCall.uniqueId}}</span>
          </div>
          <div class="call-flow-info-item flex">
            <h4 class="black-text mb-0 mt-0">Start Time: </h4>
            <span class="black-text ml-10">{{callFlowTimeFormat(currentCall.start)}}</span>
          </div>
          <div class="call-flow-info-item flex">
            <h4 class="black-text mb-0 mt-0">Duration: </h4>
            <span class="black-text ml-10">{{convertTime(currentCall.duration)}}</span>
          </div>
        </div>
        <div class="flex-three mt-5">
          <div class="call-flow-info-item flex">
            <h4 class="black-text mt-0 mb-0">Caller Number: </h4>
            <span class="ml-10 black-text">{{numberFormatter(currentCall.callerIdNumber)}}</span>
          </div>
          <div class="call-flow-info-item flex">
            <h4 class="black-text mb-0 mt-0">Number Dialed: </h4>
            <span class="black-text ml-10">{{numberFormatter(currentCall.dialedNum)}}</span>
          </div>
          <div class="call-flow-info-item flex">
            <h4 class="black-text mb-0 mt-0">Disposition: </h4>
            <span class="black-text ml-10">{{currentCall.disposition}}</span>
          </div>
        </div>
      </div>

      <div>
        <div class="flex items-center justify-center pt-20">
          <div style="height:300px" class="vxe-table-height table-width card-base card-shadow--medium">
            <vxe-grid
              round
              border="inner"
              height="300px"
              auto-resize
              empty-text="No Data"
              highlight-hover-row
              show-overflow="tooltip"
              :data="callData"
              :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
              :columns="eventColumns"
            />
          </div>
        </div>
      </div>

    </el-dialog>
    <div id="call-records-view" class="page-table scrollable only-y">
      <el-dialog
        width="440px"
        :visible="modalVisible"
        :before-close="handleCloseModal"
        :close-on-click-modal="false"
      >
        <h2 class="form-section-header">
          Filter Settings
        </h2>
        <h3 class="black-text mb-10">Select Date Range</h3>
        <el-date-picker
          :clearable="false"
          class="mr-10"
          style="margin-left: auto;"
          v-model="historyDateRange"
          type="datetimerange"
          align="right"
          unlink-panels
          format="yyyy-MM-dd HH:mm"
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
          :picker-options="datePickerOptions">
        </el-date-picker>

        <el-form id="records-advanced-modal" class="form-modal">

          <h3 class="black-text mb-10">Select Call Direction</h3>
          <el-radio-group v-model="direction">
            <el-radio-button type="default" label="Inbound">Inbound</el-radio-button>
            <el-radio-button label="Outbound">Outbound</el-radio-button>
            <el-radio-button label="Internal">Internal</el-radio-button>
            <el-radio-button label="All">All</el-radio-button>
          </el-radio-group>


          <h3 class="black-text mb-0">Filter By</h3>
          <el-select
            v-model="primaryFilter"
            placeholder="Select Filter"
            clearable
            style="margin-top:0;"
            v-if="userIsReportsAdmin"
          >
            <template slot="prefix">
              Filter By
            </template>
            <el-option value="branch" label="Branch"/>
            <el-option value="callerName" label="Caller name" />
            <el-option value="phoneNumber" label="Phone number"/>
            <el-option value="callId" label="Call Id"/>
            <el-option value="user" label="User"/>
          </el-select>

          <dads-select
            v-if="primaryFilter === 'user' && userIsReportsAdmin"
            v-model="extNumber"
            placeholder="Select A User"
            allow-create
            remote
            filterable
            clearable
            :remote-method="searchExtensions"
          >
            <el-option
              v-for="(item, index) in extOptions"
              :key="index"
              :label="item.name + '-' + item.number"
              :value="item.number"
            />
            <template slot="prefix">
              Filter By User
            </template>
          </dads-select>

          <dads-select
            v-if="primaryFilter === 'user' && !userIsReportsAdmin"
            v-model="extNumber"
            placeholder="Select An Agent"
            allow-create
            remote
            filterable
            clearable
            :remote-method="searchQueueMembers"
          >
            <el-option
              v-for="(item, index) in extOptions"
              :key="index"
              :label="item.membername.replace(/_/g, ' ') + ' - ' + item.memberdevice.split('-')[0]"
              :value="item.memberdevice.split('-')[0]"
            />
            <template slot="prefix">
              Filter By Queue Member
            </template>
          </dads-select>

          <dads-select
            v-if="primaryFilter === 'branch'"
            v-model="branch"
            placeholder="Select A Branch"
            filterable
          >
            <el-option
              v-for="(item, index) in branchOptions"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
            <template slot="prefix">
              Filter By Branch
            </template>
          </dads-select>

          <dads-select
            v-if="primaryFilter === 'phoneNumber'"
            v-model="phoneNumber"
            placeholder="Select A Number"
            filterable
            clearable
            remote
            allow-create
            :remote-method="searchNumbers"
          >
            <el-option
              v-for="(item, index) in numberOptions"
              :key="index"
              :label="numberFormatter(item.number)"
              :value="item.number"
            />
            <template slot="prefix">
              Filter By Number
            </template>
          </dads-select>

          <el-input
            v-if="primaryFilter === 'callerName'"
            v-model="callerName"
            placeholder="Enter name"
          >
            <template slot="prefix">
              Caller name
            </template>
          </el-input>

          <el-input
            v-if="primaryFilter === 'callId'"
            v-model="callId"
            placeholder="Enter Call Id"
          >
            <template slot="prefix">
              Call Id
            </template>
          </el-input>

          <h3 class="black-text mb-5 mt-5">Select Dispositions</h3>
          <el-checkbox-group v-model="dispositions" class="dispositions-group">
            <div>
              <el-checkbox label="ANSWERED">Answered</el-checkbox>
            </div>
            <div>
              <el-checkbox label="NO ANSWER">No Answer</el-checkbox>
            </div>
            <div>
              <el-checkbox label="BUSY">Busy</el-checkbox>
            </div>
            <div>
              <el-checkbox label="FAILED">Failed</el-checkbox>
            </div>
          </el-checkbox-group>

          <el-button
            @click="doAdvanced"
            class="mt-20"
          >
            Update
          </el-button>
        </el-form>

      </el-dialog>

      <div class="no-table-box page-header">

        <div class="flex justify-space-between mb-20">
          <h2 class="mb-0 mt-0 text-left">
            <v-svg sprite="file-audio" class="voxo-purple"></v-svg>
            Call Recordings
          </h2>
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px;"></i>
            Total: {{ total | number }}
          </el-tag>
        </div>

        <div class="flex align-center mb-20">
          <el-radio-group v-model="presetSelection" @change="doPreset" class="hidden-xs-only">
            <el-radio-button type="default" label="yesterday">Yesterday</el-radio-button>
            <el-radio-button type="default" label="last10">Last 10 Days</el-radio-button>
            <el-radio-button label="lastMonth">Last 30 Days</el-radio-button>
          </el-radio-group>

          <el-tooltip placement="top" :content="selectedDateRange">
            <el-button
              @click="modalVisible = true;"
              class="ml-10"
            >
              Filter
            </el-button>
          </el-tooltip>
          <el-button
            @click="resetTable"
            v-if="advancedActive"
            style="background-color: #f25a6b; color: #fff;"
          >
            Reset
          </el-button>
          <el-pagination
            small
            background
            layout="prev, pager, next"
            @current-change="pageSet"
            @next-click="pageNext"
            @prev-click="pagePrevious"
            :current-page="page"
            :page-size="50"
            :pager-count="5"
            :total="total"
            v-if="total > limit"
            style="margin-left: auto;"
          />
        </div>

        <div class="vxe-table-height card-base card-shadow--medium">
          <vxe-grid
            round
            border="inner"
            ref="xGrid"
            height="100%"
            auto-resize
            empty-text="No Data"
            show-overflow="tooltip"
            highlight-hover-row
            @cell-click="cellClicked"
            @cell-mouseenter="rowHover"
            @cell-mouseleave="rowLeave"
            :data="tableData"
            :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
            :loading="loadingData"
            :columns="tableColumns"
          />
        </div>

      </div>
    </div>
  </div>


</template>

<script>
import feathersClient, {apiV2Host} from '@/feathers/feathers-client';
import debounce from 'lodash/debounce';
import moment from "moment";
import uniqBy from "lodash/uniqBy";
import DadsSelect from '@/components/select';
import {phoneNumberFormatter} from "@/globals/globals";
export default {
  name: 'CallRecordsTable',
  props: {
    branchOptions: {required: true}
  },
  components: { DadsSelect },
  data() {
    return {
      visibleActionsId: null,
      from: null,
      to: null,
      search: '',
      page: 1,
      limit: 50,
      total: 0,
      loadingData: false,
      advancedActive: false,
      modalVisible: false,
      historyModalVisible: false,
      presetSelection: 'last10',
      tableData: [],
      dispositions: ['ANSWERED', 'NO ANSWER', 'BUSY', 'FAILED'],
      primaryFilter: '',
      phoneNumber: '',
      extNumber: '',
      branch: '',
      callerName: '',
      callId: '',
      numberOptions: [],
      extOptions: [],
      startDate: null,
      endDate: null,
      direction: 'All',
      currentCall: null,
      callData: [],
      lastFlowId: null,
      exportCSV: false,
      whoAnswered: '',
      historyDateRange: [
        moment(),
        moment()
      ],
      datePickerOptions: {
        shortcuts: [{
          text: 'Last week',
          onClick(picker) {
            const end = moment(moment().format('YYYY-MM-DD')).add(1, 'day').subtract(1, 'minute');
            const start = moment(moment().subtract(1, 'week').format('YYYY-MM-DD'));
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last month',
          onClick(picker) {
            const end = moment(moment().format('YYYY-MM-DD')).add(1, 'day').subtract(1, 'minute');
            const start = moment(moment().subtract(1, 'month').format('YYYY-MM-DD'));
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last 3 months',
          onClick(picker) {
            const end = moment(moment().format('YYYY-MM-DD')).add(1, 'day').subtract(1, 'minute');
            const start = moment(moment().subtract(3, 'months').format('YYYY-MM-DD'));
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last 6 months',
          onClick(picker) {
            const end = moment(moment().format('YYYY-MM-DD')).add(1, 'day').subtract(1, 'minute');
            const start = moment(moment().subtract(6, 'months').format('YYYY-MM-DD'));
            picker.$emit('pick', [start, end]);
          }
        },	{
          text: "Last year",
          onClick(picker) {
            const end = moment(moment().format("YYYY-MM-DD")).add(1, "day").subtract(1, "minute");
            const start = moment(moment().subtract(12, "months").format("YYYY-MM-DD"));
            picker.$emit("pick", [start, end]);
          },
        }],
      },
      eventColumns: [
        {
          field: "event",
          title: "Event",
          sortable: false,
          showOverflow: false,
          width: 500
        },
        {
          field: "time",
          title: "Time",
          sortable: false,
          minWidth: 250,
          showOverflow: false
        },
      ],
      tableColumns: [
        {
          field: 'sprite',
          title: '',
          width: 50,
          slots: {
            default: ({row}) => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-purple" sprite="file-audio"/>
                </div>
              ]
            }
          }
        },
        {
          field: 'start',
          title: 'Time',
          minWidth: 150,
          slots: {
            default: ({row}) => {
              return [
                <span>{this.timeFormatter(row.start)}</span>
              ]
            }
          }
        },
        {
          field: 'callerIdNumber',
          title: 'Caller Number',
          minWidth: 200,
          showOverflow: true,
          slots: {
            default: ({row}) => {
              return [
                <span>{row.direction === 'OUT' && row.ani ? `${this.numberFormatter(row.callerIdNumber)} | ${this.numberFormatter(row.ani)}`: this.numberFormatter(row.callerIdNumber)}</span>
              ]
            }
          }
        },
        {
          field: 'callerIdName',
          title: 'Caller Name',
          minWidth: 200,
          showOverflow: true
        },
        {
          field: 'dialedNum',
          title: 'Dialed Number',
          minWidth: 150,
          slots: {
            default: ({row}) => {
              return [
                <span>{this.numberFormatter(row.dialedNum)}</span>
              ]
            }
          }
        },
        {
          field: 'direction',
          title: 'Direction',
          minWidth: 125
        },
        {
          field: 'disposition',
          title: 'Disposition',
          minWidth: 150
        },
        {
          field: 'duration',
          title: 'Duration',
          minWidth: 100,
          slots: {
            default: ({row}) => {
              return [
                <span>{this.convertTime(row.duration)}</span>
              ]
            }
          }
        },
        {
          field: 'whoAnswered',
          title: 'Who Answered',
          minWidth: 150,
          slots: {
            default: ({ row }) => {
              return [<span>{this.numberFormatter(row.whoAnswered)}</span>];
            },
          },
        },
        {
          field: 'packetLoss',
          title: 'Packet Loss',
          minWidth: 120,
          slots: {
            default: ({row}) => {
              return [
                <span>{row.qos ? `${row.packetLoss} %` : 'N/A'}</span>
              ]
            }
          }
        },
        {
          field: 'percentJitter',
          title: 'Jitter',
          minWidth: 100,
          slots: {
            default: ({row}) => {
              return [
                <span>{row.qos ? `${row.percentJitter} %` : 'N/A'}</span>
              ]
            }
          }
        },
        {
          field: 'actions',
          title: '',
          minWidth: '100',
          showOverflow: false,
          slots: {
            default: ({row}) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-button
                    id={'edit-'+ row.id}
                    icon="mdi mdi-music-note"
                    onClick={() => this.getCallRecording(row)}
                    class="table-action-button icon-blue"
                  />
                  <el-button
                    id={'delete-'+row.id}
                    icon="mdi mdi-history"
                    onClick={() => this.getCallHistory(row)}
                    class="table-action-button icon-green"
                  />
                </div>
              ]
            }
          }
        }
      ]
    }
  },
  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user(){
      return this.$store.state.auth.user;
    },
    userOffsetMinutes(){
      return this.$store.state.userTimeOffset;
    },
    selectedDateRange(){
      if(this.endDate && this.startDate){
        const dateStart = moment(this.startDate).format('M/D/YY HH:mm');
        const dateEnd = moment(this.endDate).format('M/D/YY HH:mm');
        return  `${dateStart} - ${dateEnd}`;
      }
    },
    userIsReportsAdmin() {
      const roles = [1,3,9,11,12];
      const { userRole, enableReporting } = this.user;
      return roles.includes(+userRole) || enableReporting;
    }
  },
  watch: {
    page: debounce(function () {
      this.queryCallRecords();
    }, 500),
    selectedTenant(){
      this.resetTable();
    }
  },
  methods: {
    queryCallRecords() {
      this.loadingData = true;
      feathersClient.service('call-history').find({
        query: {
          queryType: 'callHistory',
          tenantId: this.selectedTenant.id,
          startDate: this.startDate,
          endDate: this.endDate,
          direction: this.direction,
          primaryFilter: this.primaryFilter,
          dispositions: this.dispositions,
          extNumber: this.extNumber,
          phoneNumber: this.phoneNumber.replace(/['":;/{}()[|\-.,<>?_=+ \]]/g, ''),
          callerName: this.callerName,
          callId: this.callId,
          whoAnswered: this.whoAnswered,
          branch: this.branch,
          recorded: 1,
          $sort: {start: -1},
          $limit: this.limit,
          $skip: this.page > 1 ? (this.limit * (this.page - 1)) : 0,
          exportCSV: this.exportCSV,
          timezone: this.user.timezone
        }
      }).then( res => {
        // console.log('the call logs response', res);
        if(!this.exportCSV){
          this.limit = res.limit;
          this.pages = Math.ceil(res.total / res.limit);
          this.total = res.total;
          this.page = this.page > this.pages ? 1 : this.page;
          this.tableData = res.data;
        }
        if(this.exportCSV){
          this.downloadCSV(res);
        }
        this.exportCSV = false;
        this.loadingData = false;
      }).catch( () => {this.loadingData = false});
    },
    resetTable(){
      this.advancedActive = false;
      this.dispositions = ['ANSWERED', 'NO ANSWER', 'BUSY', 'FAILED'];
      this.primaryFilter = "";
      this.extNumber = "";
      this.branch = "";
      this.phoneNumber = "";
      this.extOptions = [];
      this.numberOptions = [];
      this.advancedActive = false;
      this.direction = 'All';
      this.doPreset('init');
    },
    async doPreset(val){
      //if this is a queue managers we will have to manually build and filter extensions
      if(!this.extNumber.length && !this.userIsReportsAdmin){
        this.primaryFilter = 'user';
        await this.findQueueMembers();
      }
      if(val === 'init'){
        this.endDate = moment(moment().format('YYYY-MM-DD')).add(1, 'day').subtract(1, 'minute').format('YYYY-MM-DD HH:mm');
        this.startDate = moment().startOf('day').format('YYYY-MM-DD');
        this.presetSelection = 'init';
        this.updateDateRangePicker();
        this.queryCallRecords();
      }
      if(val === 'last10'){
        this.endDate = moment(moment().format('YYYY-MM-DD')).add(1, 'day').subtract(1, 'minute').format('YYYY-MM-DD HH:mm');
        this.startDate = moment().subtract(9, 'days').format('YYYY-MM-DD');
        this.presetSelection = 'last10';
        this.updateDateRangePicker();
        this.queryCallRecords();
      }
      if(val === 'lastMonth'){
        this.endDate = moment(moment().format('YYYY-MM-DD')).add(1, 'day').subtract(1, 'minute').format('YYYY-MM-DD HH:mm');
        this.startDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
        this.presetSelection = 'lastMonth';
        this.updateDateRangePicker();
        this.queryCallRecords();
      }
      if(val === 'yesterday'){
        this.endDate = moment().startOf('day').subtract(1, 'minute').format('YYYY-MM-DD HH:mm');
        this.startDate = moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm');
        this.presetSelection = 'yesterday';
        this.updateDateRangePicker();
        this.queryCallRecords();
      }
    },
    doAdvanced(){
      this.startDate = moment(this.historyDateRange[0]).format('YYYY-MM-DD HH:mm');
      this.endDate = moment(this.historyDateRange[1]).format('YYYY-MM-DD HH:mm');
      this.queryCallRecords();
      this.handleCloseModal();
      this.advancedActive = true;
    },
    doExport(){
      this.$confirm(`Export data for ${this.total} records?`, {
        type: 'warning'
      }).then(() => {
        this.exportCSV = true;
        this.queryCallRecords();
      }).catch(() => true);
    },
    downloadCSV(data){
      const fileBlob = new Blob([data.file]);
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(fileBlob);
      link.download = data.downloadName;
      link.click();
    },
    searchNumbers(query){
      const searchTerm = (query + '').replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0')
      feathersClient.service('dids').find({
        query: {
          tenantId: this.selectedTenant.id,
          number: {$like: `%${searchTerm}%`},
          $limit: 25
        }
      }).then( res => {
        this.numberOptions = res;
      });
    },
    searchExtensions(query){
      const searchTerm = (query + '').replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0')
      feathersClient.service('extensions').find({
        query: {
          tenantId: this.selectedTenant.id,
          $or: [
            {number: {$like: `%${searchTerm}%`}},
            {name: {$like: `%${searchTerm}%`}}
          ],
          $limit: 25
        }
      }).then( res => {
        this.extOptions = res;
      })
    },
    numberFormatter(val) {
      return phoneNumberFormatter(val);
    },
    timeFormatter(value) {
      const offsetMinutes = Math.abs(this.userOffsetMinutes);
      return this.userOffsetMinutes < 0
        ? moment(value).subtract(offsetMinutes, 'minutes').format('M/DD h:mm A')
        : moment(value).add(offsetMinutes, 'minutes').format('M/DD h:mm A');
    },
    callFlowTimeFormat(time){
      const offsetMinutes = Math.abs(this.userOffsetMinutes);
      return this.userOffsetMinutes < 0
        ? moment(time).subtract(offsetMinutes, 'minutes').format('M/DD h:mm A')
        : moment(time).add(offsetMinutes, 'minutes').format('M/DD h:mm A');
    },
    handleCloseModal(){
      this.modalVisible = false;
      this.historyModalVisible = false;
      this.callData = [];
    },
    updateDateRangePicker(){
      this.historyDateRange = [
        moment(this.startDate),
        moment(this.endDate)
      ]
    },
    pageNext () {
      if (this.page < this.pages) {
        this.page += 1;
      }
    },
    pagePrevious () {
      if (this.page > 1) {
        this.page -= 1;
      }
    },
    pageSet (page) {
      this.page = page;
    },
    cellClicked(data) {
      if(data.column.property !== 'actions'){
        this.getCallRecording(data.row);
      }
    },

    rowHover(data){
      this.visibleActionsId = data.row.id;
    },

    rowLeave(){
      this.visibleActionsId = "";
    },
    async getCallHistory(row){
      if(row.uniqueId !== this.lastFlowId){
        this.loadingData = true;
        this.lastFlowId = row.uniqueId;
        this.callId = row.callId;
        await feathersClient.service('call-history').get(null, {
          query: {
            tenantId: this.selectedTenant.id,
            ...row
          }
        }).then( res => {
          this.historyModalVisible = true;
          this.loadingData = false;
          this.currentCall = res;
        });
      }
      this.historyModalVisible = true;
    },
    getCallRecording(row){
      this.$emit('fetchCallRecording', row);
    },
    async buildFlowChart() {
      const url = `${apiV2Host}/admin/reporting/calls/call-journey`;
      const body = {
        callId: this.callId,
      };
      const callRecords = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + this.$store.state.auth.accessToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      const { callJourney } = await callRecords.json();
      for (let i = 0; callJourney.length > i; i++) {
        this.callData.push({
          event: callJourney[i].data,
          time: moment(callJourney[i].timestamp).format("hh:mm:ss.SSS A")
        });
      }
    },
    convertTime(time) {
      const hours = Math.floor(time / 3600);
      const remainderSeconds = time % 3600;
      const minutes = Math.floor(remainderSeconds / 60);
      const seconds = Math.round(remainderSeconds % 60);
      if (hours > 0) {return hours + 'hr ' + minutes + 'm';}
      if (minutes > 0) {return minutes + 'm';}
      if (seconds > 0) {return seconds + 's';}
      return '0';
    },
    async findQueueMembers(){
      const {adminQueues} = this.user;
      const allowedMembers = await feathersClient.service('queuemembers-allowed').find({
        query: {
          queueName: {$in: adminQueues},
          $limit: 25,
          $sort: {
            membername: 1
          }
        }
      });
      const members = await feathersClient.service('queuemembers').find({
        query: {
          queueName: {$in: adminQueues},
          $limit: 25,
          $sort: {
            membername: 1
          }
        }
      });
      const allMembers = [...allowedMembers, ...members];
      this.extOptions = uniqBy(allMembers, 'membername');
      this.extNumber = this.extOptions[0].memberdevice.split('-')[0];
    },
    async searchQueueMembers(query){
      const {adminQueues} = this.user;
      if(query.length){
        const allowedMembers = await feathersClient.service('queuemembers-allowed').find({
          query: {
            queueName: {$in: adminQueues},
            membername: {$like: `%${query}%`},
            $limit: 25,
            $sort: {
              membername: 1
            }
          }
        });
        const members = await feathersClient.service('queuemembers').find({
          query: {
            queueName: {$in: adminQueues},
            membername: {$like: `%${query}%`},
            $limit: 25,
            $sort: {
              membername: 1
            }
          }
        });
        const allMembers = [...allowedMembers, ...members];
        this.extOptions = uniqBy(allMembers, 'membername');
      } else{
        this.extOptions = [];
      }
    }
  },
  mounted() {
    this.doPreset('init');
  },

  filters: {
    number (value) {
      return !isNaN(value)
        ? new Intl.NumberFormat('en-US').format(value)
        : value;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables.scss';
.el-form{
  .el-select{
    margin-left: 0;
    margin-top: 0;
    margin-bottom: 0;
  }
}
.dispositions-group{
  .el-checkbox{
    margin-left: 0;
    display: inline-block;
    margin-top: 5px;
  }
}
.flex-three{
  display: flex;
  >*{
    flex-basis: 33.3333333%;
  }
}
</style>
